import React, { Fragment } from "react";
import { Line } from 'react-chartjs-2';

class LinesGraph extends React.Component {

  render() {
    const options = {
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            stacked: true,
          }
        ]
      }
    };

    return (
      <Fragment>
        <Line data={this.props.data} options={options} />
      </Fragment>
    )
  }
}

export default LinesGraph;